import { observer } from "mobx-react";
import { Box } from "@material-ui/core";
import { useEffect, useState } from "react";
import {
  ChatSection,
  useLoanCommunicationStore,
} from "@roc/feature-communication";
import { ChatContainer } from "@chatscope/chat-ui-kit-react";

interface ChatRoomDialogProps {
  conversationSid: string;
}

export const ChatRoomDialog = observer(
  ({ conversationSid }: ChatRoomDialogProps) => {
    const { loanCommunicationStore } = useLoanCommunicationStore();
    const [showLoading, setShowLoading] = useState<boolean>(false);

    const loadChat = () => {
      setShowLoading(true);
      loanCommunicationStore.reset();
      loanCommunicationStore.loadOneConversation(conversationSid, (isError) => {
        if (!isError) {
          loanCommunicationStore.setCurrentConversation(
            loanCommunicationStore.conversations[conversationSid],
          );
          setShowLoading(false);
        }
      });
    };


    useEffect(() => {
      loadChat();
    }, []);

    return (
      <>
        <Box
          height={"75vh"}
          style={{
            borderRadius: 16,
            overflow: 'hidden',
          }}
        >
          <ChatSection
            as={ChatContainer}
            communicationStore={loanCommunicationStore}
            allowJoinConversation={true}
            allowLeaveConversation={true}
            showSnippet={false}
            showEmailAddress={false}
            allowManageParticipants={true}
            allowAddInternalParticipants={true}
            allowAddParticipants={true}
            allowRemoveParticipants={true}
            onDownloadConversation={undefined}
            onUnarchiveConversation={() => {}}
            showLoading={showLoading}
          />
        </Box>
      </>
    );
  },
);
